import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { NgxLoadingModule } from 'ngx-loading';
import { NgTiltModule } from "@geometricpanda/angular-tilt";

import { LiteYoutubeModule } from '../../../../shared/modules/lite-youtube/lite-youtube.module';
import { ServiceLayoutV2Component } from './service-layout-v2/service-layout-v2.component';
import { ServicePurchaseComponent } from './service-layout-v2/service-purchase/service-purchase.component';
import { ServiceFaqComponent } from './service-layout-v2/service-faq/service-faq.component';
import { PublicSharedModule } from '../../shared/public-shared.module';
import { TranslatePipeModule } from '../../../../shared/pipes/translate.pipe';
import { DropdownMenuModule } from '../../../../shared/modules/dropdown-menu/dropdown-menu.module';

import {SafePipeModule} from '../../../../shared/pipes/safe.pipe';
import {CdnPipeModule} from '../../../../shared/pipes/cdn.pipe';
import {GameMainComponent} from './service-layout-v2/game-main/game-main.component';
import {GameFeaturesComponent} from './service-layout-v2/game-features/game-features.component';
import {OrderFlowComponent} from './service-layout-v2/order-flow/order-flow.component';
import {BoosterPlaysComponent} from './service-layout-v2/booster-plays/booster-plays.component';

import {PromoSelectModalComponent} from './modals/promo-select/promo-select-modal.component';

import { GameCharacterSelectComponent } from './modals/game-character-select/game-character-select.component';
import {PositionSelectComponent} from './modals/position-select/position-select.component';

import {LolDuoGamesComponent} from './services/lol-duo-games/lol-duo-games.component';
import {DivisionSelectModalComponent} from './modals/division-select/division-select-modal.component';
import {LpSelectModalComponent} from './modals/lp-select/lp-select-modal.component';
import {QueueSelectModalComponent} from './modals/queue-select/queue-select-modal.component';
import {RankSelectModalComponent} from './modals/rank-select/rank-select-modal.component';
import {ServerSelectModalComponent} from './modals/server-select/server-select-modal.component';
import {FlagModule} from '../../../../shared/modules/flag/flag.module';

import { TftDivisionsComponent } from './services/tft-divisions/tft-divisions.component';
import { TftPlacementsComponent } from './services/tft-placements/tft-placements.component';
import { TftNetWinsComponent } from './services/tft-net-wins/tft-net-wins.component';
import { TftNormalGamesComponent } from './services/tft-normal-games/tft-normal-games.component';
import { TftDoubleUpComponent } from './services/tft-double-up/tft-double-up.component';
import { TftDivisionSelectModalComponent } from "./modals/tft-division-select/tft-division-select-modal.component";
import { TftRankSelectModalComponent } from "./modals/tft-rank-select/tft-rank-select-modal.component";

import {MasterySelectModalComponent} from './modals/mastery-select/mastery-select-modal.component';
import {LolCharacterSelectComponent} from './modals/lol-character-select/lol-character-select.component';
import {AmazonPayModule} from '../../shared/modules/amazon-pay.module';
import {ValorantDivisionsComponent} from './services/valorant-divisions/valorant-divisions.component';
import {ValorantNetWinsComponent} from './services/valorant-net-wins/valorant-net-wins.component';
import {ValorantPlacementsComponent} from './services/valorant-placements/valorant-placements.component';
import {ValorantDuoGamesComponent} from './services/valorant-duo-games/valorant-duo-games.component';
import {ValorantNormalGamesComponent} from './services/valorant-normal-games/valorant-normal-games.component';
import {ValorantRankSelectComponent} from './modals/valorant-rank-select/valorant-rank-select.component';
import {ValorantDivisionSelectComponent} from './modals/valorant-division-select/valorant-division-select.component';


import {GameSelectorModule} from '../../shared/modules/game-selector/game-selector.module';

import {LolDivisionsComponent} from './services/lol-divisions/lol-divisions.component';
import {LolPlacementsComponent} from './services/lol-placements/lol-placements.component';
import {LolNetWinsComponent} from './services/lol-net-wins/lol-net-wins.component';
import {LolNormalGamesComponent} from './services/lol-normal-games/lol-normal-games.component';
import {LolMasteriesComponent} from './services/lol-masteries/lol-masteries.component';
import {LolLevelingComponent} from './services/lol-leveling/lol-leveling.component';
import {LolCustomizationModalComponent} from './modals/lol-customization-modal/lol-customization-modal.component';
import { ValorantCustomizationModalComponent } from './modals/valorant-customization-modal/valorant-customization-modal.component';
import {ServiceSelectorComponent} from './service-selector/service-selector.component';

import {PlatformSelectModalComponent} from "./modals/platform-select/platform-select-modal.component";

import { WildRiftRankSelectComponent } from './modals/wild-rift-rank-select/wild-rift-rank-select.component';
import { WildRiftDivisionSelectComponent } from './modals/wild-rift-division-select/wild-rift-division-select.component';
import { WildRiftLpSelectComponent } from './modals/wild-rift-lp-select/wild-rift-lp-select.component';
import { WildRiftDivisionsComponent } from './services/wild-rift-divisions/wild-rift-divisions.component';
import { WildRiftPlacementsComponent } from './services/wild-rift-placements/wild-rift-placements.component';
import { WildRiftNormalGamesComponent } from './services/wild-rift-normal-games/wild-rift-normal-games.component';

import { Cs2RatingSelectComponent } from "./modals/cs2-rating-select/cs2-rating-select.component";
import { Cs2RankSelectComponent } from "./modals/cs2-rank-select/cs2-rank-select.component";
import { Cs2MapsSelectComponent } from "./modals/cs2-maps-select/cs2-maps-select.component";
import { Cs2PremierComponent } from "./services/cs2-premier/cs2-premier.component";
import { Cs2CompetitiveComponent } from "./services/cs2-competitive/cs2-competitive.component";
import { Cs2PlacementsComponent } from "./services/cs2-competitive-placements/cs2-placements.component";
import { Cs2PremierNetWinsComponent } from "./services/cs2-competitive-net-wins/cs2-premier-net-wins.component";

import { ApexDivisionsComponent } from './services/apex-divisions/apex-divisions.component';
import { ApexPlacementsComponent } from "./services/apex-placements/apex-placements.component";
import { ApexBadgesComponent } from "./services/apex-badges/apex-badges.component";
import { ApexUnrankedWinsComponent } from './services/apex-unranked-wins/apex-unranked-wins.component';
import { ApexRankSelectComponent } from "./modals/apex-rank-select/apex-rank-select.component";
import { ApexLpSelectModalComponent } from "./modals/apex-lp-select/apex-lp-select-modal.component";
import { ApexDivisionSelectComponent } from "./modals/apex-division-select/apex-division-select.component";
import { ApexBadgeSelectComponent } from "./modals/apex-badge-select/apex-badge-select.component";

import { MarvelDivisionsComponent } from './services/marvel-divisions/marvel-divisions.component';
import { MarvelQuickWinsComponent } from './services/marvel-quick-wins/marvel-quick-wins.component';
import { MarvelNetWinsComponent } from './services/marvel-net-wins/marvel-net-wins.component';
import { MarvelLevelingComponent } from './services/marvel-leveling/marvel-leveling.component';

import { OverwatchDivisionsComponent } from "./services/overwatch-divisions/overwatch-divisions.component";
import { OverwatchRankSelectModalComponent } from "./modals/overwatch-rank-select/overwatch-rank-select-modal.component";
import { OverwatchCustomizationModalComponent } from "./modals/overwatch-customization-modal/overwatch-customization-modal.component";


export function tftMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'tft-boost' ? ({consumed: url}) : null;
}

export function valorantMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'valorant-boost' ? ({consumed: url}) : null;
}

export function lolMatcher(url: UrlSegment[]): UrlMatchResult {
  return (url.length === 1 && url[0].path === 'lol-boost') || (url.length === 2 && url[1].path === 'lol-boost') ? ({consumed: url}) : null;
}

export function apexMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'apex-boost' ? ({consumed: url}) : null;
}

export function cs2Matcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'cs2' ? ({consumed: url}) : null;
}

export function wildRiftMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'wild-rift-boost' ? ({consumed: url}) : null;
}

export function overwatchMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'overwatch-boost' ? ({consumed: url}) : null;
}

export function marvelRivalsMatcher(url: UrlSegment[]): UrlMatchResult {
  return url.length === 1 && url[0].path === 'marvel-rivals-boost' ? ({consumed: url}) : null;
}

const routes: Routes = [
  {component: LolDivisionsComponent, matcher: lolMatcher},
  {component: TftDivisionsComponent, matcher: tftMatcher},
  {component: ValorantDivisionsComponent, matcher: valorantMatcher},
  {component: WildRiftDivisionsComponent, matcher: wildRiftMatcher},
  {component: OverwatchDivisionsComponent, matcher: overwatchMatcher},
  {component: MarvelDivisionsComponent, matcher: marvelRivalsMatcher},

  {path: 'boosting-services', component: ServiceSelectorComponent},

  {path: 'lol-boost/placements', component: LolPlacementsComponent},
  {path: ':lang/lol-boost/placements', component: LolPlacementsComponent},
  {path: 'lol-boost/net-wins', component: LolNetWinsComponent},
  {path: ':lang/lol-boost/net-wins', component: LolNetWinsComponent},
  {path: 'lol-boost/normal-wins', component: LolNormalGamesComponent},
  {path: ':lang/lol-boost/normal-wins', component: LolNormalGamesComponent},
  {path: 'lol-boost/games', component: LolDuoGamesComponent},
  {path: ':lang/lol-boost/games', component: LolDuoGamesComponent},
  {path: 'lol-boost/champion-mastery', component: LolMasteriesComponent},
  {path: ':lang/lol-boost/champion-mastery', component: LolMasteriesComponent},
  {path: 'lol-boost/leveling', component: LolLevelingComponent},
  {path: ':lang/lol-boost/leveling', component: LolLevelingComponent},

  {path: 'tft-boost/double-up', component: TftDoubleUpComponent},
  {path: 'tft-boost/placements', component: TftPlacementsComponent},
  {path: 'tft-boost/net-wins', component: TftNetWinsComponent},
  {path: 'tft-boost/normal-wins', component: TftNormalGamesComponent},

  {path: 'valorant-boost/placements', component: ValorantPlacementsComponent},
  {path: 'valorant-boost/net-wins', component: ValorantNetWinsComponent},
  {path: 'valorant-boost/unrated-wins', component: ValorantNormalGamesComponent},
  {path: 'valorant-boost/duo-games', component: ValorantDuoGamesComponent},

  { path: 'apex-legends/rank-boosting', component: ApexDivisionsComponent },
  { path: 'apex-legends/badge-boosting', component: ApexBadgesComponent },
  { path: 'apex-legends/provisional-boosting', component: ApexPlacementsComponent },
  { path: 'apex-legends/unranked-wins', component: ApexUnrankedWinsComponent },

  {path: 'cs2/premier-boosting', component: Cs2PremierComponent},
  {path: 'cs2/placements-boosting', component: Cs2PlacementsComponent},
  {path: 'cs2/competitive-boosting', component: Cs2CompetitiveComponent},
  {path: 'cs2/premier-wins-boosting', component: Cs2PremierNetWinsComponent},

  { path: 'wild-rift-boost/placements', component: WildRiftPlacementsComponent },
  { path: 'wild-rift-boost/normal-wins', component: WildRiftNormalGamesComponent },

  { path: 'marvel-rivals-boost/net-wins', component: MarvelNetWinsComponent },
  { path: 'marvel-rivals-boost/quick-wins', component: MarvelQuickWinsComponent },
  { path: 'marvel-rivals-boost/leveling', component: MarvelLevelingComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    PublicSharedModule,
    FlagModule,
    DropdownMenuModule,
    AmazonPayModule,
    NgxLoadingModule,
    GameSelectorModule,
    SafePipeModule,
    CdnPipeModule,
    LiteYoutubeModule,
    NgTiltModule,
    TranslatePipeModule
  ],
  declarations: [
    OverwatchDivisionsComponent,
    LolDivisionsComponent,
    LolNetWinsComponent,
    LolMasteriesComponent,
    LolPlacementsComponent,
    LolNormalGamesComponent,
    LolDuoGamesComponent,
    DivisionSelectModalComponent,
    LpSelectModalComponent,
    Cs2PremierComponent,
    Cs2PlacementsComponent,
    Cs2PremierNetWinsComponent,
    Cs2CompetitiveComponent,
    PositionSelectComponent,
    PromoSelectModalComponent,
    QueueSelectModalComponent,
    PlatformSelectModalComponent,
    RankSelectModalComponent,
    Cs2RatingSelectComponent,
    Cs2RankSelectComponent,
    Cs2MapsSelectComponent,
    OverwatchRankSelectModalComponent,
    ServerSelectModalComponent,

    ServiceLayoutV2Component,
    ServicePurchaseComponent,
    ServiceFaqComponent,
    MasterySelectModalComponent,
    LolCharacterSelectComponent,
    LolLevelingComponent,
    ValorantDivisionsComponent,
    ValorantNetWinsComponent,
    ValorantPlacementsComponent,
    ValorantDuoGamesComponent,
    ValorantNormalGamesComponent,
    ValorantRankSelectComponent,
    ApexRankSelectComponent,
    ValorantDivisionSelectComponent,

    LolCustomizationModalComponent,
    ValorantCustomizationModalComponent,
    OverwatchCustomizationModalComponent,
    ServiceSelectorComponent,
    GameMainComponent,
    GameFeaturesComponent,
    OrderFlowComponent,
    BoosterPlaysComponent,
    GameCharacterSelectComponent,

    TftRankSelectModalComponent,
    TftDivisionSelectModalComponent,
    TftPlacementsComponent,
    TftDivisionsComponent,
    TftNetWinsComponent,
    TftNormalGamesComponent,
    TftDoubleUpComponent,

    WildRiftDivisionsComponent,
    WildRiftRankSelectComponent,
    WildRiftDivisionSelectComponent,
    WildRiftLpSelectComponent,
    WildRiftPlacementsComponent,
    WildRiftNormalGamesComponent,

    ApexDivisionsComponent,
    ApexUnrankedWinsComponent,
    ApexLpSelectModalComponent,
    ApexDivisionSelectComponent,
    ApexBadgeSelectComponent,
    ApexPlacementsComponent,
    ApexBadgesComponent,

    MarvelDivisionsComponent,
    MarvelQuickWinsComponent,
    MarvelNetWinsComponent,
    MarvelLevelingComponent
  ],
    exports: [
        DivisionSelectModalComponent,
        GameFeaturesComponent
    ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PublicEloBoostModule {
}
